import type { ColumnFilters } from '@/models/flowFilter.type';
import type { IngestionSortColumn } from '@/models/ingestion.type';
import {
  applyFiltersToSearchParams,
  type ColumnFilterKinds,
} from '@/shared/utils/column-filters-url';
import type { RelationColumns } from '@/shared/utils/flow-filter-utils';

export const INGESTIONS_PATH = '/admin/ingestions';

/** Paramètres d'URL du tableau des ingestions, en plus d'un paramètre par colonne filtrable. */
export const INGESTIONS_SORT_PARAM = 'sort';
export const INGESTIONS_DIRECTION_PARAM = 'dir';
export const INGESTIONS_PAGE_PARAM = 'page';
export const INGESTIONS_PAGE_SIZE_PARAM = 'size';

/** Type du filtre de chaque colonne filtrable (relu depuis l'URL). `sus` contient des identifiants. */
export const ingestionFilterKinds = {
  id: 'number-range',
  date_heure_debut: 'date-range',
  date_heure_fin: 'date-range',
  fluxname: 'select',
  sus: 'select',
  manuel: 'boolean',
  emetteur: 'text',
  statut: 'select',
  volume: 'number-range',
  nb_element: 'number-range',
  nb_succes: 'number-range',
  nb_rejet: 'number-range',
  nb_erreur: 'number-range',
} as const satisfies ColumnFilterKinds;

/** Le filtre `sus` porte sur la colonne `su_ids` du flow (identifiants encadrés de virgules). */
export const ingestionRelationColumns: RelationColumns = { sus: 'su_ids' };

type IngestionsUrlOptions = {
  filters?: ColumnFilters;
  sort?: { column: IngestionSortColumn; direction: 'asc' | 'desc' };
};

/** Lien vers le tableau des ingestions déjà filtré et trié (ex. depuis la page des SUS). */
export const buildIngestionsUrl = ({ filters = {}, sort }: IngestionsUrlOptions = {}): string => {
  const params = applyFiltersToSearchParams(new URLSearchParams(), filters, ingestionFilterKinds);
  if (sort) {
    params.set(INGESTIONS_SORT_PARAM, sort.column);
    params.set(INGESTIONS_DIRECTION_PARAM, sort.direction);
  }
  const query = params.toString();
  return query ? `${INGESTIONS_PATH}?${query}` : INGESTIONS_PATH;
};

/** Lien vers les ingestions d'un service d'urgence. */
export const buildSusIngestionsUrl = (susId: number): string =>
  buildIngestionsUrl({ filters: { sus: { kind: 'select', values: [String(susId)] } } });
